import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';


// If Role(s) available, pass Roles as prop to RequireAuth Component
const RequireAuth = () => {
    const auth = useSelector(state => state.auth)
    const location = useLocation()
    return (
        // auth?.roles?.find(role => allowedRoles?.includes(role))
        //     ? <Outlet/>
        //     : auth?.user 
        //         ? <Navigate to='/unauthorize' state={{from: location}} replace/>
        //         : <Navigate to='/' state={{from: location}} replace/>
        auth?.user 
            ? <Outlet/>
            : <Navigate to='/' state={{from: location}} replace/>
    )
}

export default RequireAuth;
